import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { Dots } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import { faUserLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import CurrencyCardIcon from '../utils/currency-card-icon.js';



class ClaimCreateForm extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;

		this.bounty = null;
		
		let isdevicewallet = false;
		let title = '';
		let wanted = '';
		let amount = 0;
		let currency = {symbol: ''};
		let signingkey = null;
		let currentcard = null;
		let balance = '';
		let bountycard = null;
		let bountycard_balance_int = 0;
		let bountycard_balance_string = '';

		this.closing = false;

		
		this.state = {
			isdevicewallet,
			title,
			wanted,
			amount,
			currency,
			signingkey,
			currentcard,
			balance,
			isBountyPaused: false,
			bountycard,
			bountycard_balance_int,
			bountycard_balance_string,
			loaded: false,
			message_text: 'loading...',
			processinginfo: 'processing submission',
			processing: false
		};
	}

	_setState(state) {
		if (this.closing !== true)
		this.setState(state);
	}

	
	// post render commit phase
	componentDidUpdate(prevProps, prevState) {
		//console.log('ClaimCreateForm.componentDidUpdate called');
		
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		// entered an address or a private key
		if (this.state.signingkey != prevState.signingkey) {
			const {isdevicewallet, currency} = this.state;

			if ( (currency) && (currency.uuid)) {
				let currentcard = null;
				let balance = '';
				
				let currencyuuid = currency.uuid;
				let options = {maincard: true, allow_readonly: true};

				this.app.createCurrencyCard(currencyuuid, this.state.signingkey, options)
				.then(card => {
					currentcard = card;

					return mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid)
				})
				.then((pos) => {
					return mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
				})
				.then((balance) => {
					this._setState({currentcard, balance});
				})
				.catch(err => {
					this._setState({currentcard, balance})
				});
			}
		}
	}

	componentDidMount() {
		console.log('ClaimCreateForm.componentDidMount called');
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();
		let rootsessionuuid = this.props.rootsessionuuid;
		
		// message translated in user's language
		let message_text = mvcmyquote.t(
			'You can copy the address of the account that will receive the funds, or its \
			private key if you want to use it to issue your own bounties. Alternatively, \
			you can generate a new card by clicking on the icon next to the box. \
			After you submit your answer by pressing the button \'Place Claim\', the issuer of \
			the bounty will be able to review it and accept or reject your claim. If your answer \
			is accepted, the funds will be automatically transferred to the address you specified.');
	
		this._setState({message_text});

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}
	
	async _countClaims() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let bounty = this.bounty;
		let bountyhash = bounty.txhash;
		let currencyuuid = bounty.currencyuuid;

		let claims = [];
		let claimscounts = [];

		claimscounts.total = 0;

		let canfetch = await mvcmyquote.canFetchTransactions(rootsessionuuid, walletuuid, currencyuuid);

		if (canfetch) {
			claims = await mvcmyquote.fetchClaims(rootsessionuuid, walletuuid, currencyuuid, bountyhash)
			.catch(err => {
				console.log('error in ClaimScanView._scan: ' + err);
			});

			for (var i = 0; i < (claims ? claims.length : 0); i++) {
				if (claimscounts[claims[i].status] !== undefined)
					claimscounts[claims[i].status]++;
				else
					claimscounts[claims[i].status] = 1;

				claimscounts.total++;
			}

		}
		
		return claimscounts;
	}

	async checkNavigationState() {
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;


		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;
		
		// check wallet is unlocked
		let unlocked = await this.app.checkWalletUnlocked()
		.catch(err => {
		});

		if (!unlocked) {
			// we open the default device wallet
			let devicewallet = await this.app.openDeviceWallet()
			.catch(err => {
			});

			walletuuid = devicewallet.uuid;

			this._setState({isdevicewallet: true});
		}
		else {
			let isdevicewallet = await this.app.isDeviceWallet(walletuuid);

			// we don't allow import of external private keys in device wallets

			this._setState({isdevicewallet});
		}

		if (app_nav_target && (app_nav_target.route == 'claim') && (app_nav_target.reached == false)) {
			let params = app_nav_target.params;
			let dataobj = params.dataobject;

			// we fetch the bounty to have a proper record
			let bounty = await mvcmyquote.fetchBounty(rootsessionuuid, walletuuid, dataobj.currencyuuid, dataobj.txhash);
			this.bounty = bounty;

			if (bounty) {
				let title = bounty.title;
				let wanted = bounty.wanted;
				let amount = bounty.amount;
				let currencyuuid = bounty.currencyuuid;

				let currency = {symbol: ''};
				let currentcard;
				let balance = '';

				let isBountyPaused = false;
				let bountycard = null;
				let bountycard_balance_int = 0;
				let bountycard_balance_string = '';


				const cur = await mvcmyquote.getCurrencyFromUUID(rootsessionuuid, currencyuuid)
				.catch(err => {});

				if (cur)
				currency = cur;

				// get currency position
				currentcard = await this.app.openCurrencyCard(currencyuuid)
				.catch(err => {});

				if (currentcard) {
					let pos = await mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid);
			
					if (pos !== undefined)
						balance = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
				}

				// get the bounty card
				let bountycardaddress = bounty.bounty_card_address;

				bountycard = await mvcmyquote.getCurrencyCardWithAddress(rootsessionuuid, walletuuid, currencyuuid, bountycardaddress)
				.catch(err => {
					console.log('error in BountyView.checkNavigationState: ' + err);
				});

				if (bountycard) {
					let pos = await mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid, bountycard.uuid);
			
					if (pos !== undefined) {
						bountycard_balance_int = await pos.toInteger();
						bountycard_balance_string = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
					}
	
				}								
				
				// counts claims
				let claimscounts = await this._countClaims()
				.catch(err => {
					console.log('error in BountyView.checkNavigationState: ' + err);
				});

				if (claimscounts) {
					// total - paid - rejected
					let claimspaid = (claimscounts[10] ? claimscounts[10] : 0);
					let claimsrejected = (claimscounts[-10] ? claimscounts[-10] : 0);
					let num_claims_out = claimscounts.total - claimsrejected - claimspaid;

					let token_amount_out = await mvcmyquote.getCurrencyAmount(rootsessionuuid, currencyuuid, amount);
					token_amount_out.multiply(num_claims_out);
					let token_amount_out_int= await token_amount_out.toInteger();

					if (token_amount_out_int >= bountycard_balance_int) {
						// if number of open claims * amount is higher than the bounty balance
						// we mark as paused
						isBountyPaused = true;
					}
				}

			
				this._setState({title, wanted, amount, currency, 
					currentcard, balance,
					isBountyPaused, 
					bountycard, bountycard_balance_int, bountycard_balance_string });
	
				dataobj.viewed = true;
			}
			else {
				this.app.error('no data object for claim create form')
			}
			
			app_nav_target.reached = true;
		}

		this._setState({loaded: true});
	}

 	// end of life
	componentWillUnmount() {
		console.log('ClaimCreateForm.componentWillUnmount called');
		
		this.closing = true;

		this.app.closeDeviceWallet();
	}

	
	
	// user actions
	async onGenerateCard() {
		console.log('onGenerateCard pressed!');

		if (this.state.currentcard)
			return;

		if (this.state.isdevicewallet !== true)
			return; // we only generate for the device wallet to avoid impacting quotes

		let mvcmodule = this.getMvcModuleObject();
		let rootsessionuuid = this.props.rootsessionuuid;

		let privatekey = await mvcmodule.generatePrivateKey(rootsessionuuid);

		this._setState({signingkey: privatekey});
	}

	async onSubmit() {
		console.log('onSubmit pressed!');
		
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		let wallet;
		let carduuid;
		let card;
		
		let { answer, amount, currency, currentcard, signingkey} = this.state;

		this._setState({processing: true});

		try {

			if (!answer || (answer.length == 0)) {
				this.app.alert('Please provide an answer before placing your claim');
				this._setState({processing: false});
				return;
			}
	
	
			if (!currency || !currency.uuid) {
				this.app.alert('You need to specify a valid currency');
				this._setState({processing: false});
				return;
			}
	
			// get wallet details
			wallet = await mvcmodule.getWalletInfo(rootsessionuuid, walletuuid);
	
			if (currentcard) {
				card = currentcard;
				carduuid = card.uuid;
			}
			else {
				if (signingkey) {
					let currencyuuid = currency.uuid;
					let options = {maincard: true, allow_readonly: true};
		
					card = await this.app.createCurrencyCard(currencyuuid, signingkey, options)
					.catch(err => {
						console.log('error in ClaimCreateForm.onSubmit: ' + err);
					});
	
					if (!card) {
						this.app.alert('could not create card from private key');
						this._setState({processing: false});
						return;
					}
				}
				else {
					this.app.alert('You need to provide your private key for ' + currency.name + ' in order to sign your claim');
					this._setState({processing: false});
					return;
				}
		
			}
	
			// we get the pretrade card to save a transaction
			let pretradecard = await mvcmyquote.getPretradeCard(rootsessionuuid, walletuuid, carduuid, currency.uuid)
			.catch(err => {
				console.log('error in ClaimCreateForm.onSubmit: ' + err);
			});
	
			if (!pretradecard) {
				this.app.alert('Could not get a card to register the claim');
				this._setState({processing: false});
				return;
			}
	
			// we top-up pretrade card to be sure being able to send a transaction
			const topupinfo = await mvcmodule.topUpCard(rootsessionuuid, walletuuid, pretradecard.uuid)		
			.catch(err => {
				console.log('error in ClaimCreateForm.onSubmit: ' + err);
			});
	
			if ((!topupinfo) || (!topupinfo.top) ) {
				this.app.alert('Could not top up account to register claim. Wait a few seconds and try again.');
				this._setState({processing: false});
				return;
			}
			else {
				let transactioninfo = await mvcmyquote.getSchemeTransactionInfo(rootsessionuuid, pretradecard.schemeuuid);

				if (topupinfo.balance <= (transactioninfo ? transactioninfo.credits_threshold :  1)) {
					this.app.alert('Account has not been topped-up yet. Wait a few seconds and try again.');
					this._setState({processing: false});
					return;
				}
			} 

			// we crypt our details with the issuer's public key
			// using our pretradecard that will provide our owner_rsa_publickey
			let bounty = this.bounty;
			let issuer_address = bounty.owner;
			let issuer_rsa_publickey = bounty.owner_rsa_publickey;
	
			let claimername = wallet.ownername
			let claimeremail = wallet.owneremail;
	
			const claimername_encrypted = await mvcmyquote.rsaEncryptString(rootsessionuuid, walletuuid, pretradecard.uuid, issuer_rsa_publickey, claimername)
			.catch(err => {
				console.log('error in ClaimCreateForm.onSubmit: ' + err);
			});
			const claimeremail_encrypted = await mvcmyquote.rsaEncryptString(rootsessionuuid, walletuuid, pretradecard.uuid, issuer_rsa_publickey, claimeremail)
			.catch(err => {
				console.log('error in ClaimCreateForm.onSubmit: ' + err);
			});
	
			// we crypt answer if this is a private submission
			let private_submission = bounty.private_submission;
			let one_submission = bounty.one_submission;
			let answer_plain = answer;
			let answer_encrypted;
	
			if (private_submission) {
				answer_encrypted = await mvcmyquote.rsaEncryptString(rootsessionuuid, walletuuid, pretradecard.uuid, issuer_rsa_publickey, answer_plain)
				.catch(err => {
					console.log('error in ClaimCreateForm.onSubmit: ' + err);
				});		
			}

			let debug_info;
			// DEBUG INFO
			// safeguard data (should not be used programmatically, will disappear with an official release)
			// get list of currency cards
 			debug_info = {};
			let cards = await mvcmyquote.getCurrencyCardList(rootsessionuuid, walletuuid, currency.uuid)
			.catch(err => {
				console.log('error in ClaimCreateForm.onSubmit: ' + err);
			});

			let currencycards = [];

			for (var i = 0; i < (cards ? cards.length : 0); i++) {
				let _currencycard = {};
				_currencycard.address = cards[i].address;

				var _privkey = await  mvcmyquote.getCardPrivateKey(rootsessionuuid, walletuuid, cards[i].uuid).catch(err => {});
				_currencycard.cansign = (_privkey ? true : false);
				_currencycard.xtra_data = cards[i].xtra_data;

				currencycards.push(_currencycard);
			}

			debug_info.currencycards = currencycards;

			debug_info.app_version = this.app.current_version;
			debug_info.fullBrowserVersion = await this.app.getFullBrowserVersion();
			debug_info.deviceinfo = await this.app.getDeviceInfo();

 			// END DEBUG INFO
	
			// send transaction
			let payingto_address = (card.address === pretradecard.address ? null : card.address);
			let claim_status = 0;
			let claimer_address = pretradecard.address;
			let claimer_rsa_publickey = pretradecard.publickeys['rsa_public_key'];
	
	
			let claim = {type: 'claim', bounty: bounty.txhash, currencyuuid: currency.uuid,
						amount, currency: currency.symbol,
						private_submission, answer: (private_submission ? answer_encrypted : answer_plain),
						payingto: payingto_address, status: claim_status,
						owner: claimer_address, owner_rsa_publickey: claimer_rsa_publickey, ownername: claimername_encrypted,  owneremail: claimeremail_encrypted,
						debug_info};

			if (one_submission) {
				var cansubmit = await mvcmyquote.canRegisterClaim(rootsessionuuid, walletuuid, pretradecard.uuid, claim)
				.catch(err => {
					console.log('error in ClaimCreateForm.onSubmit: ' + err);
				});

				if (cansubmit !== true) {
					this.app.alert('You can claim only once for this bounty');
					this._setState({processing: false});
					return;
				}
			}
	
			let txhash = await mvcmyquote.registerClaim(rootsessionuuid, walletuuid, pretradecard.uuid, claim)
			.catch(err => {
				console.log('error in ClaimCreateForm.onSubmit: ' + err);
			});
	
			if (!txhash) {
				this.app.alert('Could not register the claim');
				this._setState({processing: false});
				return;
			}
	
			// get share link
			var claimurl = await this.app.getShareLink(txhash, currency.uuid);
	
			//this.app.alert('Send url ' + claimurl);
	
			// go to list view (to let time for the blockchain to commit the transactions)
			let params = {action: 'view', txhash, currencyuuid: currency.uuid};
	
			await this.app.gotoRoute('claims', params);
	
			this._setState({processing: false});
	
			return true;
		}
		catch(e) {
			console.log('exception in onSubmit: ' + e);
			this.app.error('exception in onSubmit: ' + e);

			this.app.alert('could not create claim')

			this._setState({processing: false});
		}

	}

	
	// rendering
	renderBountyCardPart() {
		let {currency, bountycard, bountycard_balance_string} = this.state;

		return (
			<div>
			{(bountycard ?
				<FormGroup className="CurrencyCard" controlId="address">
				<span className="CardIconCol">
					<CurrencyCardIcon
						app={this.app}
						currency={currency}
						card={bountycard}
					/>
				</span>
				<span className="CardBalanceCol">
					<FormLabel>Bounty Balance</FormLabel>
					<FormControl
						className="CardBalanceCol"
						disabled
						autoFocus
						type="text"
						value={bountycard_balance_string}
					/>
				</span>
				</FormGroup> :
				<></>
			)}
			</div>
		);
	}

	renderMainCardPart() {
		let { loaded, isdevicewallet, currency, currentcard, signingkey, balance } = this.state;

		return (
			<span>
				{(currentcard ?
					<FormGroup className="CurrencyCard" controlId="address">
						<span className="CardIconCol">
							<CurrencyCardIcon
								app={this.app}
								currency={currency}
								card={currentcard}
							/>
						</span>
						<span className="CardBalanceCol">
							<FormLabel>Your Balance</FormLabel>
							<FormControl
								className="CardBalanceCol"
								disabled
								autoFocus
								type="text"
								value={balance}
							/>
						</span>
					</FormGroup> :
					<FormGroup controlId="signingkey">
						<FormLabel>{(isdevicewallet ? 'Your Address ' : 'Your Private Key or Address ')}{(currency && currency.name ? 'for ' + currency.name : '')}</FormLabel>
						<FormGroup className="ClaimerCardLine">
							<FormControl
								autoFocus
								type="text"
								value={(signingkey ? signingkey : '')}
								onChange={e => this._setState({signingkey: e.target.value})}
							/>
							<div className="GenerateCardIcon">
							<FontAwesomeIcon 
								icon={faUserLock}
								size="3x"
								onClick={this.onGenerateCard.bind(this)}
							/>
							</div>
						</FormGroup>
					</FormGroup>
				)}
			</span>

		);
	}

	renderPlaceClaimButton() {
		let { loaded, isBountyPaused, currentcard, bountycard_balance_int} = this.state;

		if (loaded) {
			return(
				<span>
					{(bountycard_balance_int ?
					(isBountyPaused ?
					<Button disabled type="submit">
						Bounty paused
					</Button> :
					<Button 
						disabled={(currentcard ? false : true)}
						onClick={this.onSubmit.bind(this)} 
						type="submit">
						Place Claim
					</Button>) :
					<Button 
					disabled
					type="submit">
					Bounty closed
					</Button>)}
				</span>);
		}
		else {
			return(	
				<Button disabled type="submit">
					loading...
				</Button>
			);
		}
	}

	renderClaimCreateForm() {
		let { loaded, isdevicewallet, title, wanted, amount, currency, answer, message_text } = this.state;
		
		return (
			<div className="Form">
				<div>
					<FormGroup controlId="title">
						<FormLabel>Bounty Title</FormLabel>
						<FormControl
							disabled
							autoFocus
							type="text"
							value={title}
							onChange={e => this._setState({title: e.target.value})}
						/>
					</FormGroup>

					<FormGroup controlId="wanted">
						<FormLabel>Wanted</FormLabel>
						<FormControl 
							disabled
							as="textarea" 
							rows="3" 
							autoFocus
							type="text"
							value={wanted}
							onChange={e => this._setState({wanted: e.target.value})}
						/>
					</FormGroup>

					{this.renderBountyCardPart()}

				
					<FormGroup className="Proposal" controlId="proposal">
						<span className="ProposalCol">
							<FormLabel>Reward</FormLabel>
							<FormControl 
								disabled
								autoFocus
								type="text"
								value={amount}
								onChange={e => this._setState({amount: e.target.value})}
							/>
						</span>

						<span className="ProposalCol">
							<FormLabel>Currency</FormLabel>
							<InputGroup>
								<FormControl 
									disabled
									autoFocus
									type="text"
									value={currency.symbol}
									onChange={e => this.onChangeCurrency(e)}
								/>
							</InputGroup>
						</span>

					</FormGroup>

					<div className="Separator"></div>

					<FormGroup controlId="answer">
						<FormLabel>Your Answer</FormLabel>
						<FormControl 
							as="textarea" 
							rows="2" 
							autoFocus
							type="text"
							value={answer}
							onChange={e => this._setState({answer: e.target.value})}
						/>
					</FormGroup>
				
					{this.renderMainCardPart()}
					
					{this.renderPlaceClaimButton()}

					<div className="TextBox">
					{message_text}
					</div>

				</div>
			</div>
		  );
	}

	render() {
		let {processing} = this.state; 

		if (processing === true) {
			return (
				<div className="Splash">
					<div>{this.state.processinginfo}</div>
					<Dots />
				</div>
			);
		}
		
		return (
			<div className="Container">
				<div className="Title">Create Claim</div>
				{ this.renderClaimCreateForm()}
			</div>
		  );
	}
	
}


// propTypes validation
ClaimCreateForm.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {ClaimCreateForm};
export default connect(mapStateToProps, mapDispatchToProps)(ClaimCreateForm);

